(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('BrokerageDeleteController',BrokerageDeleteController);

    BrokerageDeleteController.$inject = ['$uibModalInstance', 'entity', 'Brokerage'];

    function BrokerageDeleteController($uibModalInstance, entity, Brokerage) {
        var vm = this;

        vm.brokerage = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Brokerage.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
